export default {
    WelcomeUser: 'Xin chào, ',
    WelcomeToMTax: 'Chào mừng bạn trải nghiệm dịch vụ Thuế điện tử MISA mTax',
    SomeManipulationComplete: 'Chỉ một vài thao tác nữa thôi chúng tôi sẽ hoàn tất thiết lập cho bạn',
    SettingEsign: 'Thiết lập chữ ký số',
    SettingEsignMTax: 'Thiết lập ký số sử dụng khi ký điện tử trên MISA MTax',
    USBToken: 'USB TOKEN',
    RegisterUSBToken: 'Để đăng ký bằng USB Token, thiết bị đang dùng cần cài đặt công cụ hỗ trợ ký số của MISA là MISA KYSO',
    IfNotSetting: 'Nếu chưa cài đặt, vui lòng tải bộ cài',
    Here: 'Tại đây',
    ViewHelp: 'Xem hướng dẫn',
    Final: 'Hoàn thành',
    Back: 'Quay lại',
    TaxCode: 'Mã số thuế/CCCD',
    PayerName: 'Người nộp thuế',
    Address: 'Địa chỉ',
    ProvinceName: 'Tỉnh/Thành phố',
    DistrictName: 'Quận/Huyện',
    WardName: 'Phường/xã',
    TaxAgentNameCollect: 'Tên cơ quan quản lý thu',
    ChapterCode: 'Mã chương',
    Next: 'Tiếp theo',
    ContactName: 'Người đại diện pháp luật',
    FinanceStartDate: 'Ngày bắt đầu năm tài chính',
    PhoneNumber: 'Điện thoại',
    Email: 'Email',
    Fax: 'Fax',
    StartedWorking: 'Bắt đầu sử dụng',
    RulesSetingEsign1: '1. Bạn cần cài đặt công cụ hỗ trợ ký số của MISA là ',
    MISAKYSO: 'MISA KYSO',
    RulesSetingEsign2: '2. Bạn cần cắm USB chứa chữ ký số khi thực hiện ký điện tử',
    DownloadMisaKYSO: 'Tải về MISA KYSO',
    Understand: 'Đã hiểu',
    MessageOnlyRegisterTCT: "Với mỗi dịch vụ Khai thuế, Nộp thuế, Tổng cục thuế chỉ chấp nhận Người nộp thuế <br>đăng ký dùng 1 nhà cung cấp. Vui lòng ngừng dịch vụ thuế điện tử của Tổng cục thuế <br>trước khi đăng ký dịch vụ MISA mTax.",
    MessageOnlyRegisterOne: 'Với mỗi dịch vụ Khai thuế, Nộp thuế, Tổng cục thuế chỉ chấp nhận Người nộp thuế <br>đăng ký sử dụng 1 nhà cung cấp. Nếu bạn chưa đăng ký ngừng dịch vụ với nhà cung cấp hiện tại,<br> liên hệ ngay với nhà cung cấp để được hướng dẫn ngừng dịch vụ.',
    MessageOnlyRegisterIndividual: 'Với mỗi dịch vụ Khai thuế, Nộp thuế, Tổng cục thuế chỉ chấp nhận Người nộp <br>thuế đăng ký dùng 1 nhà cung cấp. Vui lòng ngừng dịch vụ thuế điện tử của Tổng cục thuế.',
    IfYouNot: 'Nếu bạn chưa',
    RegisterStoped: 'đăng ký ngừng',
    ContactWithThem: 'dịch vụ với nhà cung cấp hiện tại, liên hệ ngay với nhà cung cấp để được hướng dẫn ngừng dịch vụ.',
    YouNeed: 'Bạn cần',
    StopService: 'ngừng dịch vụ',
    StopFromTCT: 'Thuế điện tử của Tổng cục thuế trước khi đăng ký sử dụng dịch vụ thuế điện tử của MISA',
    Welcome: 'Chào mừng',
    TaxReady: 'Khai thuế hay Nộp thuế, MISA mTax đều sẵn sàng đáp ứng.',
    RegisterEsignForWorking: 'Đăng ký sử dụng dịch vụ thuế điện tử qua T-VAN MISA ngay để bắt đầu sử dụng!',
    RegisterNow: 'Đăng ký ngay',
    AfterUseMisa: 'Trước khi sử dụng MISA, bạn đã dùng',
    DoingOtherService: 'dịch vụ thuế điện tử nào chưa?',
    PostEsignTCT: 'Cổng thuế điện tử của </br>Tổng cục thuế',
    OtherTVAN: 'Dịch vụ thuế điện tử của các nhà cung cấp khác',
    NotDoingAnyEsign: 'Tôi chưa từng dùng dịch vụ thuế điện tử nào',
    UserWaring: 'Người nộp thuế cần lưu ý',
    RegisterStopedUpperFirstCase: 'Đăng ký ngừng',
    FrequentQuestion: 'Câu hỏi thường gặp',
    WatchMovieTutorial: 'Xem phim hướng dẫn',
    TaxPayerInfo: 'Thông tin người nộp thuế',
    Agreement: 'Thỏa thuận sử dụng dịch vụ',
    VersionDate: 'Phiên bản ngày:',
    AcceptAgreement: 'Tôi đã đọc và đồng ý với thỏa thuận sử dụng dịch vụ',
    NowYouCanPayer: 'Từ giờ bạn có thể nộp thuế điện tử ngay trên MISA mTax',
    MisaHasTaxPayer: 'Misa đã được cấp quyền triển khai dịch vụ Nộp thuế điện tử',
    Cancel: 'Hủy bỏ',
    Skip: 'Bỏ qua',
    AcceptHistory: 'Lịch sử xác nhận',
    UpdateAgreement: 'Cập nhật thỏa thuận sử dụng dịch vụ',
    MISAHasUpdateAgreement: 'Để đảm bảo quyền lợi của khách hàng, MISA đã cập nhật một số nội dung của Thỏa thuận sử dụng dịch vụ.',
    AcceptAbout30Days: 'Vui lòng xác nhận các thay đổi trước ngày ',
    AcceptAbout30DaysUser: 'Vui lòng thông báo cho người dùng có vai trò Quản trị thực hiện xác nhận trước ngày ',
    BestRegards: 'Trân trọng',
    MISACompanyName: 'Công ty cổ phần MISA',
    Later: 'Để sau',
    Accept: 'Đồng ý',
    StopService: 'Tạm dừng dịch vụ',
    MisaUpdateFrom: 'MISA đã cập nhật thỏa thuận sử dụng dịch vụ từ ngày',
    PleaseAccept: "Vui lòng xác nhận thỏa thuận dể tiếp tục sử dụng.",
    PleaseAcceptUser: "Vui lòng thông báo cho người dùng có vai trò quản trị thực hiện xác nhận.",
    HasMoreThan30Days: 'MISA đã cập nhật thỏa thuận sử dụng dịch vụ từ ngày ##Date##. Vui lòng xác nhận thỏa thuận dể tiếp tục sử dụng.',
    HasMoreThan30DaysUser: 'MISA đã cập nhật thỏa thuận sử dụng dịch vụ từ ngày ##Date##. Vui lòng thông báo cho người dùng có vai trò quản trị thực hiện xác nhận.',
    AdminNotAccept: 'Mã số thuế chưa xác nhận Thỏa thuận sử dụng dịch vụ. Để bắt đầu sử dụng, vui lòng thông báo cho người dùng có vai trò Quản trị thực hiện xác nhận.',
    ChapterCodeDescription: 'Mã chương là mã của doanh nghiệp theo loại hình kinh doanh và cấp quản lý. Mã chương được cấp khi Người nộp thuế Đăng ký kinh doanh.',
    };